import React from "react";
import { AddToolTip, Link } from "../../../../../components";
import { Button } from "react-bootstrap";
import { usCurrency } from "../../../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";

const FundingDetailsCard = ({
  list,
  showPopup,
  showFundPopup,
  codeId,
  isClassification = false,
}) => {
  return (
    <div>
      {list &&
        list.map((data, index) => (
          <>
            <div className="payroll-file-table-view">
              <div className="d-flex justify-content-space-between align-items-center align-self-center">
                <p className="ft-14 black-text column-plan-name">
                  <AddToolTip name={data.planName} placement="bottom">
                    <span>{data.planName || ""}</span>
                  </AddToolTip>
                </p>
                <p className="ft-14 black-text column-plan-id">
                  {data.rkPlanNumber}
                </p>
                <p className="ft-14 black-text font-weight-500 column-employee">
                  {data.employeesCount}
                </p>
                <p className="ft-14 black-text font-weight-500 column-total-funding">
                  {usCurrency(data.totalFunding)}
                </p>
                {/* <Link
                  className="ft-14 link-text mt-0 column-source-details"
                  onClick={(event) => {
                    isClassification
                      ? showPopup(data.planId, codeId)
                      : showPopup(data.planId);
                  }}
                >
                  View
                </Link> */}
                <>
                  {data.fundingStatus === 1 ? (
                    <div className={"column-fund-status allocate-funds"}>
                      <div className="d-flex justify-content-center align-items-center">
                        <Button
                          className="allocate-fund-btn"
                          variant="secondary"
                          onClick={() => {
                            isClassification
                              ? showFundPopup(data, codeId)
                              : showFundPopup(data);
                          }}
                        >
                          Allocate funds
                        </Button>
                      </div>
                    </div>
                  ) : data.fundingStatus === 2 ? (
                    <>
                      <div
                        className="column-fund-status confirm-funds"
                        style={{ padding: "5px 20px 15px" }}
                      >
                        <div className="d-flex flex-column justify-content-center align-items-center ft-12 grey-text">
                          <div className="mb-1">
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              size="18px"
                              color="#828282"
                              className="mr-1"
                            />
                            Funds Allocated
                          </div>
                          <Button
                            className="confirm-fund-btn"
                            variant="secondary"
                            onClick={() =>
                              isClassification
                                ? showFundPopup(data, codeId)
                                : showFundPopup(data)
                            }
                          >
                            Confirm funds
                          </Button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="column-fund-status funded">
                      <div className="d-flex flex-column justify-content-center align-items-center ft-12">
                        <div className="payroll-file-card green-text">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            size="18px"
                            color="green"
                            className="mr-1"
                          />
                          <span>Funds Received</span>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              </div>
            </div>
          </>
        ))}
    </div>
  );
};

export default FundingDetailsCard;
